/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/DeleteSSHKeyDialog" />
import React = require("react");
import { filterXSS } from "xss";

import { VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { Link } from "VSSUI/Link";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { SSHToken } from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Contracts";
import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";

export interface IProfileDeleteSSHKeyDialogProps {
    onDismiss: () => void;
    onConfirm: (key: SSHToken) => void;
    selectedToken: SSHToken;
}

export default class DeleteSSHKeyDiaolog extends VssComponent<IProfileDeleteSSHKeyDialogProps> {
    public render() {
        const { selectedToken: { token }, onConfirm, onDismiss } = this.props;
        return (
            <Dialog
                titleProps={{ text: Resources.RemoveKeyTitle }}
                onDismiss={onDismiss}
                footerButtonProps={[
                    {
                        text: Resources.Cancel,
                        onClick: onDismiss
                    },
                    {
                        disabled: false,
                        danger: true,
                        text: Resources.Delete,
                        onClick: () => onConfirm(this.props.selectedToken)
                    }
                ]}
            >
                <FormatComponent format={Resources.RemoveKeyDialog}>
                    <span className="font-weight-heavy">{filterXSS(token.displayName)}</span>
                </FormatComponent>
                <p>
                    <FormatComponent format={Resources.RemoveKeyMessage}>
                        <Link rel="nofollow noopener" target="_blank" aria-label={Resources.SecondaryAriaText} href={Resources.ConnectToYourGitRepos}>
                            {Resources.LearnMoreAboutSSHKeys}
                        </Link>
                    </FormatComponent>
                </p>
            </Dialog>
        );
    }
}
